import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function CountUp({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 2000;
          const steps = 60;
          const increment = target / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}{suffix}
    </span>
  );
}

export default function Stats() {
  const { t } = useTranslation();

  const stats = [
    { value: 30, suffix: '+', label: t('stats_years') },
    { value: 1250000, suffix: '+ m²', label: t('stats_area') },
    { value: 150, suffix: '+', label: t('stats_projects') },
    { value: 50, suffix: '+', label: t('stats_engineers') },
  ];

  return (
    <section className="bg-[#1A2332] py-16">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="text-3xl md:text-4xl lg:text-5xl font-black text-[#E8A020] mb-2 whitespace-nowrap">
              <CountUp target={stat.value} suffix={stat.suffix} />
            </div>
            <div className="text-white/60 text-sm tracking-wide uppercase">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
